import {CommonPersonalDevelopmentXlsxDataProcessor} from '../export-care-plan-common-personal-development-xlsx-data';

export class PersDevelopOtherXlsxDataProcessor extends CommonPersonalDevelopmentXlsxDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
